import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import auth from './auth';
import account from './account';
import categories from './categories';
import client from './client';
import home from './home';
import insights from './insights';
import insightsCriteria from './insightsCriteria';
import locations from './locations';
import organisations from './organisations';
import travelPast from './travelPast';
import systemModals from './systemModals';
import reports from './reports';
import homeInsights from './homeInsights';
import workInsights from './workInsights';
import pois from './pois';
import mobileAppsList from './mobileAppsList';
import brandAffinity from './brandAffinity';
import mobileDevices from './mobileDevices';
import audienceBuilder from './audienceBuilder';
import route from './route';


const rootReducer  = (history) =>  combineReducers({
  auth,
  account,
  categories,
  client,
  home,
  insights,
  insightsCriteria,
  locations,
  organisations,
  router: connectRouter(history),
  travelPast,
  reports,
  systemModals,
  homeInsights,
  workInsights,
  pois,
  mobileAppsList,
  brandAffinity,
  mobileDevices,
  audienceBuilder,
  route
});

export default rootReducer;
